import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MODEL_REDUCER_TOKEN, modelReducerProvider, rootReducerKey } from './model.reducer';
import { ModelEffects } from './model.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(rootReducerKey, MODEL_REDUCER_TOKEN),
    EffectsModule.forFeature([ModelEffects])
  ],
  providers: [
    modelReducerProvider
  ]
})
export class ModelStoreModule { }
